export const LOCALES = {
  ru: {
    code: 'ru',
    label: 'RU',
    title: 'Уведомление о рисках',
    subtitle:
      'При совершении операций с ETF на цифровые активы в рамках особого режима регулирования',
    infoRows: [
      {
        label: 'Участник',
        value: 'АО «Teniz Capital Investment Banking»',
      },
      {
        label: 'Основание',
        value:
          'Договор №17 от 29.05.2026 об осуществлении деятельности в рамках особого режима регулирования',
      },
      {
        label: 'Срок действия особого режима',
        value: '29.05.2026 – 23.12.2030',
      },
      {
        label: 'Инструменты / площадка',
        value:
          'ETF на цифровые активы, сектор KASE Global, площадка «Смешанная»',
      },
    ],
    intro:
      'Настоящее уведомление подготовлено в целях информирования клиента о рисках, связанных с совершением операций с ETF на цифровые активы в рамках особого режима регулирования. Перед совершением операций клиенту необходимо внимательно ознакомиться с настоящим уведомлением, оценить свои инвестиционные цели, финансовое положение, инвестиционный опыт и допустимый уровень риска.',
    importantLabel: 'Важно:',
    important:
      'операции с ETF на цифровые активы могут сопровождаться повышенной волатильностью и риском убытков. Клиент самостоятельно принимает инвестиционные решения и несет риск их последствий.',
    section1Title: '1. Общая информация об особом режиме',
    section1Paragraphs: [
      'Особый режим регулирования предусматривает возможность обращения ETF на цифровые активы на фондовой бирже в секторе KASE Global на площадке «Смешанная».',
      'Деятельность осуществляется на основании Договора № 17 от 29.05.2026, заключенного с уполномоченным органом — Агентством Республики Казахстан по регулированию и развитию финансового рынка.',
      'В период действия Договора на деятельность участников, осуществляемую в рамках особого режима регулирования, не распространяются следующие нормы нормативных правовых актов Национального Банка Республики Казахстан:',
    ],
    excludedNorms: [
      {
        title:
          'Пункт 53-1 Правил осуществления брокерской и (или) дилерской деятельности на рынке ценных бумаг, порядка проведения брокером и (или) дилером банковских операций,',
        rest: ' утвержденных постановлением Правления Национального Банка Республики Казахстан от 3 февраля 2014 года №9.',
      },
      {
        title:
          'Пункт 33-1 Правил осуществления деятельности по управлению инвестиционным портфелем,',
        rest: ' утвержденных постановлением Правления Национального Банка Республики Казахстан от 3 февраля 2014 года №10.',
      },
      {
        title:
          'Часть вторая пункта 3 Требований к эмитентам и их ценным бумагам, допускаемым к обращению на фондовой бирже, а также к отдельным категориям официального списка фондовой биржи,',
        rest: ' утвержденных постановлением Правления Национального Банка Республики Казахстан от 27 марта 2017 года №54.',
      },
    ],
    section1Closing: [
      'Практическое значение для потребителя заключается в том, что операции с ETF на цифровые активы осуществляются в рамках специального регуляторного режима, предусматривающего отдельные особенности по сравнению со стандартным режимом регулирования рынка ценных бумаг.',
      'Такой режим допускает обращение соответствующих инструментов в условиях временного неприменения отдельных регуляторных требований, указанных выше. В связи с этим клиенту необходимо учитывать, что часть стандартных требований, обычно применяемых к соответствующей деятельности или инструментам на рынке ценных бумаг, в рамках особого режима может не применяться в объеме, предусмотренном Договором.',
      'При этом участие АО «Teniz Capital Investment Banking» в особом режиме регулирования не устраняет рыночные, ликвидные, операционные, технологические, регуляторные и иные риски, связанные с совершением операций с ETF на цифровые активы. Клиент самостоятельно принимает инвестиционные решения и несет риск последствий таких решений.',
    ],
    section2Title: '2. Основные риски',
    mainRisks: [
      {
        title: 'Рыночный риск.',
        text: 'Стоимость ETF на цифровые активы может изменяться под влиянием рыночной конъюнктуры, спроса и предложения, динамики базовых цифровых активов, процентных ставок, валютных курсов и иных факторов. Цена инструмента может снижаться, что может привести к убыткам.',
      },
      {
        title: 'Риск высокой волатильности.',
        text: 'Цифровые активы могут характеризоваться существенными и резкими колебаниями стоимости. Волатильность базовых активов может существенно влиять на цену ETF.',
      },
      {
        title: 'Риск ликвидности.',
        text: 'На рынке может отсутствовать достаточный объем заявок на покупку или продажу инструмента. Клиент может столкнуться с невозможностью оперативно продать инструмент по ожидаемой цене.',
      },
      {
        title: 'Регуляторный риск.',
        text: 'Особый режим регулирования является специальным режимом допуска к деятельности. Изменение законодательства, требований уполномоченного органа, условий особого режима или правил биржи может повлиять на порядок обращения инструментов.',
      },
      {
        title: 'Риск прекращения особого режима.',
        text: 'Особый режим может быть прекращен досрочно в случаях, предусмотренных законодательством и условиями Договора. Это может повлиять на порядок дальнейшего обращения инструментов и обслуживание открытых позиций.',
      },
      {
        title: 'Операционный и технологический риск.',
        text: 'Возможны сбои в работе торговой, расчетной, учетной, депозитарной, информационной или иной инфраструктуры, а также ошибки или задержки при исполнении операций.',
      },
      {
        title: 'Инфраструктурный и кастодиальный риск.',
        text: 'ETF на цифровые активы могут быть связаны с инфраструктурой хранения, учета и обращения цифровых активов. Сбои или ограничения в такой инфраструктуре могут повлиять на стоимость и обращение инструментов.',
      },
      {
        title: 'Риск самостоятельного инвестиционного решения.',
        text: 'Информация, предоставляемая клиенту, не является гарантией доходности. Клиент самостоятельно принимает решение о совершении операции и несет риск возможных убытков.',
      },
    ],
    section3Title: '3. Важные предупреждения',
    warnings: [
      'Настоящее уведомление носит информационный характер и не является индивидуальной инвестиционной рекомендацией, публичной офертой или гарантией доходности.',
      'До совершения операций клиенту рекомендуется самостоятельно оценить все риски, а при необходимости получить независимую финансовую, юридическую, налоговую или иную профессиональную консультацию.',
      'Перечень рисков, описанных в пункте 2 не является исчерпывающим, и клиенту следует учитывать, что могут существовать иные риски, не указанные в настоящем Уведомлении.',
      'АО «Teniz Capital Investment Banking» вправе отказать в совершении операции в случаях, предусмотренных законодательством, внутренними документами, правилами комплаенс-контроля, требованиями AML/KYC, санкционными ограничениями, правилами биржи или условиями договора с клиентом.',
      'Информация об условиях, тарифах, порядке оказания услуг и перечне документов размещается на сайте АО «Teniz Capital Investment Banking» и может обновляться в случае изменения законодательства, условий особого режима, тарифов, внутренних документов или рыночной практики.',
    ],
    confirmationIntro:
      'Подписывая настоящее Уведомление либо подтверждая ознакомление с ним в электронном виде, я подтверждаю, что:',
    confirmationPoints: [
      'ознакомился(-лась) с содержанием настоящего Уведомления в полном объёме;',
      'понимаю характер операций с ETF на цифровые активы и особенности особого режима регулирования, в рамках которого такие операции совершаются;',
      'принимаю риски, связанные с совершением операций с ETF на цифровые активы, и самостоятельно несу ответственность за последствия принимаемых мной инвестиционных решений.',
    ],
    fields: {
      fullName: 'ФИО / Наименование',
      iinBin: 'ИИН / БИН',
    },
    submit: 'Подтверждаю',
    submitHint:
      'Нажимая на кнопку «Подтверждаю», вы подтверждаете ознакомление с уведомлением о рисках',
    successTitle: 'Спасибо! Данные успешно отправлены.',
    closeLabel: 'Закрыть',
    errors: {
      fullName: 'Укажите ФИО / Наименование',
      iinBinRequired: 'Укажите ИИН / БИН',
      iinBinLength: 'ИИН / БИН должен состоять из 12 цифр',
      iinBinInvalid: 'Введите корректный ИИН / БИН',
      submitFailed:
        'Не удалось отправить подтверждение. Попробуйте ещё раз.',
    },
  },
  en: {
    code: 'en',
    label: 'EN',
    title: 'Risk Disclosure',
    subtitle:
      'For Transactions in Digital Asset ETFs under the Special Regulatory Regime',
    infoRows: [
      {
        label: 'Participant',
        value: 'JSC “Teniz Capital Investment Banking”',
      },
      {
        label: 'Basis',
        value:
          'Agreement No. 17 dated 29 May 2026 on conducting activities under the Special Regulatory Regime',
      },
      {
        label: 'Term of the Special Regulatory Regime',
        value: '29 May 2026 – 23 December 2030',
      },
      {
        label: 'Instruments / Trading Platform',
        value:
          'Digital Asset ETFs, KASE Global sector, “Mixed” trading platform',
      },
    ],
    intro:
      'This Risk Disclosure has been prepared to inform the Client of the risks associated with transactions in Digital Asset ETFs conducted under the Special Regulatory Regime. Before entering into any transactions, the Client should carefully review this Disclosure and assess their investment objectives, financial position, investment experience, and acceptable level of risk.',
    importantLabel: 'Important:',
    important:
      'Transactions in Digital Asset ETFs may involve increased volatility and a risk of loss. The Client makes investment decisions independently and assumes the risks and consequences thereof.',
    section1Title: '1. General Information on the Special Regulatory Regime',
    section1Paragraphs: [
      'The Special Regulatory Regime provides for the possibility of trading Digital Asset ETFs on the stock exchange in the KASE Global sector on the “Mixed” trading platform.',
      'The activities are carried out pursuant to Agreement No. 17 dated 29 May 2026, concluded with the authorized body, the Agency of the Republic of Kazakhstan for Regulation and Development of the Financial Market.',
      'During the term of the Agreement, the following provisions of the regulatory legal acts of the National Bank of the Republic of Kazakhstan do not apply to the activities of participants carried out under the Special Regulatory Regime:',
    ],
    excludedNorms: [
      {
        title:
          'Paragraph 53-1 of the Rules for Conducting Brokerage and/or Dealer Activities in the Securities Market and the Procedure for Conducting Banking Operations by a Broker and/or Dealer,',
        rest: ' approved by Resolution No. 9 of the Board of the National Bank of the Republic of Kazakhstan dated 3 February 2014.',
      },
      {
        title:
          'Paragraph 33-1 of the Rules for Conducting Investment Portfolio Management Activities,',
        rest: ' approved by Resolution No. 10 of the Board of the National Bank of the Republic of Kazakhstan dated 3 February 2014.',
      },
      {
        title:
          'The second part of paragraph 3 of the Requirements for Issuers and Their Securities Admitted to Trading on a Stock Exchange, as well as for Certain Categories of the Official List of a Stock Exchange,',
        rest: ' approved by Resolution No. 54 of the Board of the National Bank of the Republic of Kazakhstan dated 27 March 2017.',
      },
    ],
    section1Closing: [
      'From a consumer perspective, this means that transactions in Digital Asset ETFs are conducted under a special regulatory regime that provides for certain specific conditions compared with the standard regulatory regime applicable to the securities market.',
      'Such regime permits the trading of the relevant instruments under conditions where certain regulatory requirements specified above are temporarily not applicable. Accordingly, the Client should take into account that some standard requirements normally applicable to the relevant activities or instruments in the securities market may not apply under the Special Regulatory Regime to the extent provided for by the Agreement.',
      'At the same time, the participation of JSC “Teniz Capital Investment Banking” in the Special Regulatory Regime does not eliminate market, liquidity, operational, technological, regulatory, or other risks associated with transactions in Digital Asset ETFs. The Client independently makes investment decisions and assumes the risks and consequences of such decisions.',
    ],
    section2Title: '2. Key Risks',
    mainRisks: [
      {
        title: 'Market Risk.',
        text: 'The value of Digital Asset ETFs may fluctuate due to market conditions, supply and demand, movements in the underlying digital assets, interest rates, foreign exchange rates, and other factors. The price of the instrument may decline, which may result in losses.',
      },
      {
        title: 'High Volatility Risk.',
        text: 'Digital assets may be characterized by significant and sudden fluctuations in value. The volatility of the underlying assets may materially affect the price of an ETF.',
      },
      {
        title: 'Liquidity Risk.',
        text: 'There may be insufficient buy or sell orders in the market for the instrument. The Client may be unable to sell the instrument promptly at the expected price.',
      },
      {
        title: 'Regulatory Risk.',
        text: 'The Special Regulatory Regime constitutes a special regime for admission to and conduct of activities. Changes in legislation, requirements of the authorized body, the terms of the Special Regulatory Regime, or exchange rules may affect the manner in which the instruments are traded.',
      },
      {
        title: 'Risk of Termination of the Special Regulatory Regime.',
        text: 'The Special Regulatory Regime may be terminated early in cases provided for by applicable legislation and the terms of the Agreement. This may affect the further trading of the instruments and the servicing of open positions.',
      },
      {
        title: 'Operational and Technological Risk.',
        text: 'Disruptions may occur in trading, settlement, accounting, depository, information, or other infrastructure, as well as errors or delays in the execution of transactions.',
      },
      {
        title: 'Infrastructure and Custody Risk.',
        text: 'Digital Asset ETFs may be associated with infrastructure used for the custody, accounting, and circulation of digital assets. Failures or restrictions affecting such infrastructure may impact the value and trading of the instruments.',
      },
      {
        title: 'Risk of Independent Investment Decisions.',
        text: 'Information provided to the Client does not constitute a guarantee of profitability. The Client independently decides whether to enter into a transaction and assumes the risk of potential losses.',
      },
    ],
    section3Title: '3. Important Warnings',
    warnings: [
      'This Disclosure is provided for informational purposes only and does not constitute individual investment advice, a public offer, or a guarantee of profitability.',
      'Before entering into any transactions, the Client is advised to independently assess all relevant risks and, where necessary, obtain independent financial, legal, tax, or other professional advice.',
      'The list of risks described in Section 2 is not exhaustive. The Client should take into account that other risks not specified in this Disclosure may also exist.',
      'JSC “Teniz Capital Investment Banking” may refuse to execute a transaction in cases provided for by applicable legislation, internal documents, compliance control rules, AML/KYC requirements, sanctions restrictions, exchange rules, or the terms of the agreement with the Client.',
      'Information regarding the terms and conditions, fees, service procedures, and list of required documents is published on the website of JSC “Teniz Capital Investment Banking” and may be updated in the event of changes in legislation, the terms of the Special Regulatory Regime, fees, internal documents, or market practice.',
    ],
    confirmationIntro:
      'By signing this Disclosure or confirming its acknowledgment electronically, I confirm that:',
    confirmationPoints: [
      'I have read and fully understood the contents of this Disclosure;',
      'I understand the nature of transactions in Digital Asset ETFs and the specifics of the Special Regulatory Regime under which such transactions are conducted;',
      'I accept the risks associated with transactions in Digital Asset ETFs and independently assume responsibility for the consequences of my investment decisions.',
    ],
    fields: {
      fullName: 'Full name / Name',
      iinBin: 'IIN / BIN',
    },
    submit: 'Confirm',
    submitHint:
      'By clicking “Confirm”, you acknowledge that you have read the risk disclosure',
    successTitle: 'Thank you! Your data has been submitted successfully.',
    closeLabel: 'Close',
    errors: {
      fullName: 'Please enter full name / name',
      iinBinRequired: 'Please enter IIN / BIN',
      iinBinLength: 'IIN / BIN must consist of 12 digits',
      iinBinInvalid: 'Please enter a valid IIN / BIN',
      submitFailed: 'Failed to submit confirmation. Please try again.',
    },
  },
  kz: {
    code: 'kz',
    label: 'KZ',
    title: 'Тәуекелдер туралы хабарлама',
    subtitle:
      'Ерекше реттеу режимі шеңберінде цифрлық активтерге қатысты ETF операцияларын жасау кезінде',
    infoRows: [
      {
        label: 'Қатысушы',
        value: '«Teniz Capital Investment Banking» АҚ',
      },
      {
        label: 'Негіздеме',
        value:
          '29.05.2026 ж. №17 Ерекше реттеу режимі шеңберінде қызметті жүзеге асыру туралы шарт',
      },
      {
        label: 'Ерекше режимнің қолданыс мерзімі',
        value: '29.05.2026 – 23.12.2030',
      },
      {
        label: 'Құралдар / алаңша',
        value:
          'Цифрлық активтерге ETF, KASE Global секторы, «Аралас» алаңшасы',
      },
    ],
    intro:
      'Осы хабарлама ерекше реттеу режимі шеңберінде цифрлық активтерге ETF-тен операцияларды жасауға байланысты тәуекелдер туралы клиентті хабардар ету мақсатында дайындалды. Операцияларды жүзеге асырмас бұрын, Клиент осы хабарламамен мұқият танысып, өзінің инвестициялық мақсаттарын, қаржылық жағдайын, инвестициялық тәжірибесін және тәуекелдің қолайлы деңгейін бағалауы керек.',
    importantLabel: 'Маңызды:',
    important:
      'цифрлық активтерге қатысты ETF-пен операциялар жоғары құбылмалылықпен және шығынға ұшырау тәуекелімен қатар жүруі мүмкін. Клиент инвестициялық шешімдерді өз бетінше қабылдайды және олардың салдарына байланысты тәуекелге өзі жауапты болады.',
    section1Title: '1. Ерекше режим туралы жалпы ақпарат',
    section1Paragraphs: [
      'Ерекше реттеу режимі цифрлық активтерге қатысты ETF-тердің KASE Global секторының «Аралас» алаңшасындағы қор биржасында айналысқа түсу мүмкіндігін көздейді.',
      'Қызмет уәкілетті орган — Қазақстан Республикасының Қаржы нарығын реттеу және дамыту агенттігімен жасалған 2026 жылғы 29 мамырдағы №17 шарт негізінде жүзеге асырылады.',
      'Шарттың қолданыс кезеңінде ерекше реттеу режимі шеңберінде жүзеге асырылатын қатысушылардың қызметіне Қазақстан Республикасы Ұлттық Банкінің мынадай нормативтік құқықтық актілерінің нормалары қолданылмайды:',
    ],
    excludedNorms: [
      {
        title:
          'Қазақстан Республикасы Ұлттық Банкі Басқармасының 2014 жылғы 3 ақпандағы № 9 қаулысымен бекітілген, Бағалы қағаздар нарығында брокерлік және (немесе) дилерлік қызметті жүзеге асыру қағидасының, брокердің және (немесе) дилердің банктік операцияларды жүргізу тәртібінің 53-1-тармағы.',
        rest: '',
      },
      {
        title:
          'Қазақстан Республикасы Ұлттық Банкі Басқармасының 2014 жылғы 3 ақпандағы № 10 қаулысымен бекітілген, Инвестициялық портфельді басқару жөніндегі қызметті жүзеге асыру қағидасының 33-1-тармағы.',
        rest: '',
      },
      {
        title:
          'Қазақстан Республикасы Ұлттық Банкі Басқармасының 2017 жылғы 27 наурыздағы № 54 қаулысымен бекітілген, Қор биржасында айналысқа жіберілетін эмитенттерге және олардың бағалы қағаздарына, сондай-ақ қор биржасының ресми тізімінің жекелеген санаттарына қойылатын талаптардың 3-тармағының екінші бөлігі.',
        rest: '',
      },
    ],
    section1Closing: [
      'Тұтынушы үшін практикалық мағынасы мынада: цифрлық активтерге қатысты ETF-пен операциялар бағалы қағаздар нарығын стандартты реттеу режимімен салыстырғанда, жекелеген ерекшеліктерді көздейтін арнайы реттеу режимі шеңберінде жүзеге асырылады.',
      'Мұндай режим жоғарыда көрсетілген жекелеген реттеушілік талаптарды уақытша қолданбау жағдайында, тиісті құралдардың айналысына жол береді. Осыған байланысты, Клиент бағалы қағаздар нарығындағы тиісті қызметке немесе құралдарға әдетте қолданылатын стандартты талаптардың бір бөлігі ерекше режим шеңберінде Шартта көзделген көлемде қолданылмауы мүмкін екенін ескеруі керек.',
      'Бұл ретте, «Teniz Capital Investment Banking» АҚ-ның ерекше реттеу режиміне қатысуы цифрлық активтерге қатысты ETF-пен операциялар жасауға байланысты нарықтық, өтімділік, операциялық, технологиялық, реттеушілік және өзге де тәуекелдерді жоймайды. Клиент инвестициялық шешімдерді өз бетінше қабылдайды және мұндай шешімдердің салдарына байланысты тәуекелді өзі көтереді.',
    ],
    section2Title: '2. Негізгі тәуекелдер',
    mainRisks: [
      {
        title: 'Нарықтық тәуекел.',
        text: 'Цифрлық активтерге қатысты ETF құны нарықтық конъюнктураның, сұраныс пен ұсыныстың, базалық цифрлық активтер динамикасының, пайыздық мөлшерлемелердің, валюта бағамдарының және басқа да факторлардың әсерінен өзгеруі мүмкін. Құралдың бағасы төмендеуі мүмкін, бұл шығындарға әкелуі ықтимал.',
      },
      {
        title: 'Жоғары құбылмалылық тәуекелі.',
        text: 'Цифрлық активтердің құны елеулі және күрт ауытқуларға бейім болуы мүмкін. Базалық активтердің құбылмалылығы ETF бағасына айтарлықтай әсер етуі мүмкін.',
      },
      {
        title: 'Өтімділік тәуекелі.',
        text: 'Нарықта құралды сатып алуға немесе сатуға арналған өтінімдердің жеткілікті көлемі болмауы мүмкін. Клиент құралды күтілетін бағамен жедел сата алмау жағдайына тап болуы мүмкін.',
      },
      {
        title: 'Реттеушілік тәуекел.',
        text: 'Ерекше реттеу режимі қызметті жүзеге асыруға рұқсат берудің арнайы режимі болып табылады. Заңнаманың, уәкілетті орган талаптарының, ерекше режим талаптарының немесе биржа қағидаларының өзгеруі құралдардың айналыс тәртібіне әсер етуі мүмкін.',
      },
      {
        title: 'Ерекше режимнің тоқтатылу тәуекелі.',
        text: 'Ерекше режим заңнамада және Шартта көзделген жағдайларда, мерзімінен бұрын тоқтатылуы мүмкін. Бұл құралдардың одан әрі айналыс тәртібіне және ашық позицияларға қызмет көрсетуге әсер етуі мүмкін.',
      },
      {
        title: 'Операциялық және технологиялық тәуекел.',
        text: 'Сауда-саттық, есеп айырысу, есепке алу, депозитарлық, ақпараттық немесе өзге де инфрақұрылымның жұмысында ақаулар, сондай-ақ операцияларды орындау кезінде қателер немесе кідірістер болуы мүмкін.',
      },
      {
        title: 'Инфрақұрылымдық және кастодиандық тәуекел.',
        text: 'Цифрлық активтерге қатысты ETF цифрлық активтерді сақтау, есепке алу және айналысқа шығару инфрақұрылымымен байланысты болуы мүмкін. Мұндай инфрақұрылымдағы ақаулар немесе шектеулер құралдардың құны мен айналысына әсер етуі мүмкін.',
      },
      {
        title: 'Инвестициялық шешімді өз бетінше қабылдау тәуекелі.',
        text: 'Клиентке ұсынылатын ақпарат кірістілікке кепілдік болып табылмайды. Клиент операция жасау туралы шешімді өз бетінше қабылдайды және ықтимал шығындардың тәуекелін өзі көтереді.',
      },
    ],
    section3Title: '3. Маңызды ескертулер',
    warnings: [
      'Осы хабарлама ақпараттық сипатта болады және жеке инвестициялық ұсыным, жария оферта немесе кірістілік кепілдігі болып табылмайды.',
      'Операцияларды жүзеге асырмас бұрын, Клиентке барлық тәуекелдерді өз бетінше бағалау, ал қажет болған жағдайда, тәуелсіз қаржылық, заңгерлік, салықтық немесе өзге де кәсіби кеңес алу ұсынылады.',
      '2-тармақта сипатталған тәуекелдер тізбесі толық болып табылмайды, сондықтан Клиент осы Хабарламада көрсетілмеген өзге де тәуекелдердің болуы мүмкін екенін ескеруге тиіс.',
      '«Teniz Capital Investment Banking» АҚ заңнамада, ішкі құжаттарда, комплаенс-бақылау қағидаларында, AML/KYC талаптарында, санкциялық шектеулерде, биржа қағидаларында немесе Клиентпен жасалған шарттың талаптарында көзделген жағдайларда, операцияны жүзеге асырудан бас тартуға құқылы.',
      'Қызмет көрсету шарттары, тарифтер, қызмет көрсету тәртібі және құжаттар тізбесі туралы ақпарат «Teniz Capital Investment Banking» АҚ-ның сайтында орналастырылады және заңнама, ерекше режимнің талаптары, тарифтер, ішкі құжаттар немесе нарықтық практика өзгерген жағдайда жаңартылуы мүмкін.',
    ],
    confirmationIntro:
      'Осы Хабарламаға қол қоя отырып немесе онымен электронды түрде танысуды растай отырып, мен мыналарды растаймын:',
    confirmationPoints: [
      'осы Хабарламаның мазмұнымен толық көлемде таныстым;',
      'цифрлық активтерге қатысты ETF-пен операциялардың сипатын және осындай операциялар жүзеге асырылатын ерекше реттеу режимінің ерекшеліктерін түсінемін;',
      'цифрлық активтерге қатысты ETF-пен операцияларды жүзеге асыруға байланысты тәуекелдерді қабылдаймын және өзім қабылдайтын инвестициялық шешімдердің салдары үшін жауапкершілікті өзім көтеремін.',
    ],
    fields: {
      fullName: 'Т.А.Ә. / Атауы',
      iinBin: 'ЖСН / БСН',
    },
    submit: 'Растаймын',
    submitHint:
      '«Растаймын» батырмасын басу арқылы сіз тәуекелдер туралы хабарламамен танысқаныңызды растайсыз',
    successTitle: 'Рахмет! Деректер сәтті жіберілді.',
    closeLabel: 'Жабу',
    errors: {
      fullName: 'Т.А.Ә. / Атауын енгізіңіз',
      iinBinRequired: 'ЖСН / БСН енгізіңіз',
      iinBinLength: 'ЖСН / БСН 12 цифрдан тұруы керек',
      iinBinInvalid: 'Дұрыс ЖСН / БСН енгізіңіз',
      submitFailed: 'Растау жіберілмеді. Қайтадан көріңіз.',
    },
  },
};

export const LANGUAGE_OPTIONS = [
  { code: 'ru', label: 'RU' },
  { code: 'kz', label: 'KZ' },
  { code: 'en', label: 'EN' },
];

export function getLocale(code) {
  return LOCALES[code] || LOCALES.ru;
}
